import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * eventlevel API
 * @author Ju
 */
export default {
  /**
   * 이벤트 등급 목록을 조회한다.
   * @author Ju
   * @return {array}  이벤트 등급 배열
   */
  getList(includeNormal) {
    return axios.get(`${baseUrl}/common/event/get-eventlevels.do`, { params: { includeNormal } });
  },
  checkExistEventlevel(eventlevelId) {
    return axios.post(`${baseUrl}/common/event/check-exist-eventlevel.do`, {
      eventlevelId,
    });
  },
  insertEventlevels(params) {
    return axios.post(`${baseUrl}/common/event/insert-eventlevel.do`, params);
  },
  updateEventlevels(params) {
    return axios.post(`${baseUrl}/common/event/update-eventlevel.do`, params);
  },
  deleteEventlevels(params) {
    return axios.post(`${baseUrl}/common/event/delete-eventlevels.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/eventlevel.js